import { render, staticRenderFns } from "./InputPlainText.vue?vue&type=template&id=4a3aff98&"
import script from "./InputPlainText.vue?vue&type=script&lang=js&"
export * from "./InputPlainText.vue?vue&type=script&lang=js&"
import style0 from "./InputPlainText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports